module.exports = __webpack_public_path__ + "img/nb_credit.c019f923.svg";